import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "#e8eaed"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M758-322q0 115-81.5 194.5T479.84-48q-115.17 0-196-79.5Q203-207 203-322v-390q0-84 59.09-142t143.5-58Q490-912 549-854t59 142v373q0 52.69-37.5 89.35Q533-213 479.92-213q-53.07 0-90-36.65Q353-286.31 353-339v-373h105v373q0 9.1 6.5 15.05Q471-318 480-318t16-5.95q7-5.95 7-15.05v-373q0-40-28.5-67.5T406-807q-40 0-69 27.55T308-712v390q0 71 50.41 120 50.42 49 122.01 49 70.58 0 121.08-49T652-322v-422h106v422Z" }, null, -1)
  ]))]))
}
export default { render: render }